<template>
  <el-row :gutter="10">
    <el-col
      :xl="{ span: 3 }"
      :lg="{ span: 3 }"
      :md="{ span: 3 }"
      :sm="{ span: 12 }"
      :xs="{ span: 12 }"
    >
      <div class="time">{{ now }}</div>
    </el-col>
    <el-col
      :xl="{ span: 16 }"
      :lg="{ span: 16 }"
      :md="{ span: 16 }"
      :sm="{ span: 10, offset: 1 }"
      :xs="{ span: 10, offset: 1 }"
    >
      <el-menu
        class="menu hidden-sm-and-down"
        default-active="/index"
        router
        mode="horizontal"
        @select="handleSelect"
        text-color="#fff"
        active-text-color="white"
        close="top-menu"
      >
        <el-menu-item index="/index" class="navigation_bar_item"
          >{{ $t('nav.home') }}</el-menu-item
        >

        <el-menu-item index="/introduction" class="navigation_bar_item"
          >{{ $t('nav.journalIntro') }}</el-menu-item
        >
        <el-menu-item index="/guidelines" class="navigation_bar_item"
          >{{ $t('nav.submission') }}</el-menu-item
        >
        <!-- 预印本下拉菜单 -->
        <el-submenu
          index="preprint"
          class="navigation_bar_item"
          popper-class="preprint-dropdown-menu"
        >
          <template slot="title">{{ $t('nav.preprint') }}</template>
          <el-menu-item index="/preprintList">{{ $t('preprint.listTitle') }}</el-menu-item>
          <el-menu-item index="/submitPreprint" v-if="isLoggedIn">{{ $t('preprint.submitStepsSubmit') }}</el-menu-item>
          <el-menu-item index="/myPreprintList" v-if="isLoggedIn">{{ $t('preprint.myTitle') }}</el-menu-item>
          <el-menu-item index="/myCommentList" v-if="isLoggedIn">{{ $t('preprint.myCommentsMenu') }}</el-menu-item>
          <el-menu-item index="/pendingPreprintList" v-if="isLoggedIn && userInfo.type === '责任编辑'">{{ $t('preprint.pendingTitle') }}</el-menu-item>
          <el-menu-item index="/pendingCommentList" v-if="isLoggedIn && userInfo.type === '责任编辑'">{{ $t('preprint.pendingCommentTitle') }}</el-menu-item>
        </el-submenu>
        <el-menu-item index="/forum" class="navigation_bar_item"
          >{{ $t('nav.forum') }}</el-menu-item
        >
        <el-menu-item index="/star" class="navigation_bar_item"
          >{{ $t('nav.risingStar') }}</el-menu-item
        >
        <el-menu-item index="/software" class="navigation_bar_item"
          >{{ $t('nav.software') }}</el-menu-item
        >
        <el-menu-item index="/training" class="navigation_bar_item"
          >{{ $t('nav.training') }}</el-menu-item
        >
      </el-menu>
      <el-menu
        class="hidden-md-and-up"
        background-color="#006a71"
        text-color="#fff"
        active-text-color="#ff8041"
        style="z-index: 1"
        router
      >
        <el-submenu>
          <template slot="title">
            <span style="color: white; font-size: 22px; font-weight: 100"
              >导航</span
            ></template
          >
          <el-menu-item index="1" class="sub_menu_item" route="index"
            >{{ $t('nav.home') }}</el-menu-item
          >
          <el-menu-item index="2" class="sub_menu_item" route="introduction"
            >{{ $t('nav.journalIntro') }}</el-menu-item
          >
          <el-menu-item index="3" class="sub_menu_item" route="guidelines"
            >{{ $t('nav.submission') }}</el-menu-item
          >
          <!-- 小屏幕预印本菜单 -->
          <el-submenu
            index="preprint"
            popper-class="preprint-dropdown-menu"
          >
            <template slot="title">{{ $t('nav.preprint') }}</template>
            <el-menu-item index="3-1" route="/preprintList">{{ $t('preprint.listTitle') }}</el-menu-item>
            <el-menu-item index="3-2" route="/submitPreprint" v-if="isLoggedIn">{{ $t('preprint.submitStepsSubmit') }}</el-menu-item>
            <el-menu-item index="3-3" route="/myPreprintList" v-if="isLoggedIn">{{ $t('preprint.myTitle') }}</el-menu-item>
            <el-menu-item index="3-4" route="/myCommentList" v-if="isLoggedIn">{{ $t('preprint.myCommentsMenu') }}</el-menu-item>
            <el-menu-item index="3-5" route="/pendingPreprintList" v-if="isLoggedIn && userInfo.type === '责任编辑'">{{ $t('preprint.pendingTitle') }}</el-menu-item>
            <el-menu-item index="3-6" route="/pendingCommentList" v-if="isLoggedIn && userInfo.type === '责任编辑'">{{ $t('preprint.pendingCommentTitle') }}</el-menu-item>
          </el-submenu>
          <el-menu-item index="4" class="sub_menu_item" route="/forum"
            >{{ $t('nav.forum') }}</el-menu-item
          >
          <el-menu-item index="5" class="sub_menu_item" route="/star"
            >{{ $t('nav.risingStar') }}</el-menu-item
          >
          <el-menu-item index="6" class="sub_menu_item" route="/software"
            >{{ $t('nav.software') }}</el-menu-item
          >
          <el-menu-item index="7" class="sub_menu_item" route="/training"
            >{{ $t('nav.training') }}</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </el-col>
    <el-col
      :xl="{ span: 2 }"
      :lg="{ span: 2 }"
      :md="{ span: 2 }"
      :sm="{ span: 1 }"
      :xs="{ span: 1 }"
    >
      <el-dropdown @command="handleLanguageChange" class="language-dropdown">
        <span class="language-selector">
          {{ currentLanguageLabel }} <i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
          <el-dropdown-item command="en-US">English</el-dropdown-item>
          <el-dropdown-item command="ja-JP">日本語</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>
    <el-col
      :xl="{ span: 1, offset: 1 }"
      :lg="{ span: 1, offset: 1 }"
      :md="{ span: 1, offset: 1 }"
      :sm="{ span: 1 }"
      :xs="{ span: 1 }"
    >
      <div class="block" v-if="userInfo != null">
        <el-dropdown>
          <el-avatar
            :size="50"
            src="../../static/materials/user.gif"
            class="el-dropdown-link"
          ></el-avatar>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>消息中心</el-dropdown-item>
            <el-dropdown-item
              ><span @click="logout()"> 退出登录 </span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div v-else>
        <el-dropdown>
          <el-avatar
            :size="50"
            src="../../static/materials/user.gif"
            class="el-dropdown-link"
          ></el-avatar>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>消息中心</el-dropdown-item>
            <el-dropdown-item
              ><span @click="logout()"> 退出登录 </span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'NavigationBarComponent',
  data () {
    return {
      now: null,
      userInfo: null

    }
  },
  computed: {
    currentLanguageLabel () {
      const langMap = {
        'zh-CN': '中文',
        'en-US': 'English',
        'ja-JP': '日本語'
      }
      return langMap[this.$i18n.locale] || '中文'
    },
    // 严格判断用户是否已登录
    isLoggedIn () {
      return this.userInfo !== null && 
             this.userInfo !== undefined && 
             this.userInfo !== '' &&
             typeof this.userInfo === 'object' &&
             Object.keys(this.userInfo).length > 0
    }
  },
  methods: {
    getNowDate () {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      const NOW_MONTHS_AGO = `${year}年${month}月${day}日`
      return NOW_MONTHS_AGO
    },

    init () {
      this.now = this.getNowDate()
      this.updateUserInfo()
    },

    // 更新用户信息的方法
    updateUserInfo () {
      const userInfo = this.$cookie.getCookie('userInfo')
      // 严格验证 userInfo 是否有效
      if (userInfo && typeof userInfo === 'object' && Object.keys(userInfo).length > 0) {
        this.userInfo = userInfo
      } else {
        this.userInfo = null
      }
    },

    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },

    handleLanguageChange (lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
    },

    logout () {
      this.$cookie.removeCookie('userInfo')
      this.$cookie.removeCookie('authority')
      this.userInfo = null
      // 触发全局事件，通知其他组件用户已登出
      this.$root.$emit('userLogout')
      // 跳转到首页并刷新
      this.$router.replace('/index').then(() => {
        this.$router.go(0)
      })
    }
  },
  mounted () {
    this.init()
    // 初始化时更新用户信息
    this.updateUserInfo()
    
    // 监听登录成功事件，自动更新用户信息
    this.$root.$on('userLoginSuccess', (userInfo) => {
      this.userInfo = userInfo
    })
    
    // 监听登出事件
    this.$root.$on('userLogout', () => {
      this.userInfo = null
    })
    
    // 监听路由变化，当路由变化时重新读取用户信息（防止cookie在其他地方被更新）
    this.$watch('$route', () => {
      this.updateUserInfo()
    })
  },
  beforeDestroy () {
    // 组件销毁前移除事件监听
    this.$root.$off('userLoginSuccess')
    this.$root.$off('userLogout')
  }
}
</script>

<style scoped>
.is-disabled {
  opacity: 1;
  color: white !important;
  font-weight: 500;
}
.is-active {
  background-color: #ff8041;
  /* background-image: linear-gradient(#ff8041, #ff8041, #ff8041); */
  color: white;
  font-size: 14px;
  font-weight: 900;
  height: 55px;
  line-height: 55px;
}

.el-menu-item {
  font-size: 14px;
  height: 60px;
}
/* .sub_menu_item {
  color: white;
  font-size: 14px;
  font-weight: 900;
  width: 20%;
} */

.navigation_bar {
  color: aliceblue;
  background-image: linear-gradient(#006a71, #005152, #002412);
}

.el-menu-item.navigation_bar_item:hover {
  background-color: #ff8041;
}

.el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 !important;
  min-width: 0 !important;
}
.menu {
  height: 60px;
  line-height: 60px;
  background-image: linear-gradient(#006a71, #005152, #002412);
  display: flex;
  align-items: center;
}

/* 修复导航项布局 - 使用深度选择器穿透 ElementUI 样式 */
>>> .menu.el-menu--horizontal {
  display: flex !important;
  border-bottom: none !important;
  width: 100% !important;
}

>>> .menu.el-menu--horizontal > .el-menu-item {
  flex: 1 !important;
  text-align: center !important;
  min-width: 100px !important;
  white-space: normal !important;
  padding: 8px 6px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 60px !important;
  line-height: 1.4 !important;
  font-size: 14px !important;
  background-color: transparent !important;
  border-bottom: none !important; /* 关键修复：移除底部边框 */
}

>>> .menu.el-menu--horizontal > .el-menu-item.is-active {
  background-color: #ff8041 !important;
  color: white !important;
  font-weight: 900 !important;
  border-bottom: none !important; /* 关键修复：激活状态也不要底部边框 */
}

>>> .menu.el-menu--horizontal > .el-menu-item:hover {
  background-color: #ff8041 !important;
  border-bottom: none !important; /* 关键修复：hover 状态也不要底部边框 */
}

>>> .menu.el-menu--horizontal > .el-submenu {
  flex: 1 !important;
  text-align: center !important;
  min-width: 100px !important;
  height: 60px !important;
  line-height: 60px !important;
}

>>> .menu.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 60px !important;
  line-height: 60px !important;
  padding: 0 6px !important;
  font-size: 14px !important;
  color: #fff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: transparent !important;
  border-bottom: none !important; /* 关键修复：移除底部边框 */
}

>>> .menu.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: #ff8041 !important;
  border-bottom: none !important; /* 关键修复：hover 状态也不要底部边框 */
}

>>> .menu.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  background-color: #ff8041 !important;
  color: white !important;
  font-weight: 900 !important;
  border-bottom: none !important; /* 关键修复：激活状态也不要底部边框 */
}

>>> .menu.el-menu--horizontal > .el-submenu.is-opened .el-submenu__title {
  background-color: #ff8041 !important;
  color: white !important;
  font-weight: 900 !important;
  border-bottom: none !important; /* 关键修复：打开状态也不要底部边框 */
}

/* 确保只有激活状态的菜单项显示橙色，hover状态不影响其他项 */
>>> .menu.el-menu--horizontal > .el-menu-item:not(.is-active):hover {
  background-color: #ff8041 !important;
}

>>> .menu.el-menu--horizontal > .el-submenu:not(.is-active):not(.is-opened) .el-submenu__title:hover {
  background-color: #ff8041 !important;
}

/* 移除 submenu 的下拉箭头图标的额外间距 */
>>> .menu.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  position: static !important;
  margin-left: 5px !important;
}

>>> .el-menu--horizontal .el-menu .el-menu-item {
  background-color: #006a71 !important;
  color: #ffffff !important;
  font-size: 13px !important;
  height: 45px !important;
  line-height: 45px !important;
}

>>> .el-menu--horizontal .el-menu .el-menu-item:hover {
  background-color: #ff8041 !important;
  color: #ffffff !important;
}

>>> .el-menu--horizontal .el-menu .el-menu-item.is-active {
  background-color: #ff8041 !important;
  color: #ffffff !important;
}

/* 修复下拉菜单文字颜色 - 深色背景浅色文字 */
>>> .el-menu--popup {
  background-color: #006a71 !important;
  border: 1px solid #005152 !important;
}

/* ElementUI 横向菜单的弹出层通常渲染为 .el-menu--popup + .el-menu--popup-bottom-start / top-start
   有些情况下 .el-menu-item 的颜色会被全局样式覆盖，需要同时覆盖 a/span */
>>> .el-menu--popup .el-menu-item,
>>> .el-menu--popup .el-menu-item a,
>>> .el-menu--popup .el-menu-item span,
>>> .el-menu--popup .el-submenu__title,
>>> .el-menu--popup .el-submenu__title span {
  background-color: #006a71 !important;
  color: #ffffff !important;
  font-size: 13px !important;
}

>>> .el-menu--popup .el-menu-item:hover,
>>> .el-menu--popup .el-menu-item:hover a,
>>> .el-menu--popup .el-menu-item:hover span,
>>> .el-menu--popup .el-submenu__title:hover,
>>> .el-menu--popup .el-submenu__title:hover span {
  background-color: #ff8041 !important;
  color: #ffffff !important;
}

>>> .el-menu--popup .el-menu-item.is-active,
>>> .el-menu--popup .el-menu-item.is-active a,
>>> .el-menu--popup .el-menu-item.is-active span {
  background-color: #ff8041 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* 兜底：有些主题会把弹出菜单的文字设置为透明/继承，强制覆盖 */
>>> .el-menu--popup-bottom-start,
>>> .el-menu--popup-top-start {
  background-color: #006a71 !important;
}

.navigation_bar_item {
  /* 移除固定宽度，改用 flex */
  /* width: 14.2%; */
}

.time {
  width: 220px;
  font-size: 22px;
  color: #fff;
  height: 55px;
  line-height: 55px;
}

.footer_item {
  height: 30px;
}

.language-dropdown {
  cursor: pointer;
  height: 55px;
  line-height: 55px;
}

.language-selector {
  color: #fff;
  font-size: 14px;
  display: inline-block;
  height: 55px;
  line-height: 55px;
}

.language-selector:hover {
  color: #ff8041;
}

/* 预印本下拉菜单样式 - 使用全局样式确保生效 */

/* 响应式样式 - 中等屏幕 */
@media (max-width: 1600px) {
  >>> .menu.el-menu--horizontal > .el-menu-item {
    font-size: 13px !important;
    padding: 8px 5px !important;
    min-width: 90px !important;
  }
}

/* 响应式样式 - 小屏幕 */
@media (max-width: 1366px) {
  >>> .menu.el-menu--horizontal > .el-menu-item {
    font-size: 12px !important;
    padding: 8px 4px !important;
    min-width: 80px !important;
  }
  
  .time {
    font-size: 18px;
    width: 180px;
  }
}

/* 响应式样式 - 超小屏幕（允许换行） */
@media (max-width: 1200px) {
  >>> .menu.el-menu--horizontal {
    flex-wrap: wrap !important;
    height: auto !important;
    min-height: 60px !important;
  }
  
  >>> .menu.el-menu--horizontal > .el-menu-item {
    flex: 0 0 auto !important;
    min-width: 100px !important;
    font-size: 12px !important;
    padding: 8px 6px !important;
  }
}
</style>

<style>
/* 预印本下拉菜单全局样式 - 不使用 scoped 确保能覆盖 ElementUI 默认样式 */
.preprint-dropdown-menu.el-menu--popup {
  background-color: #006a71 !important;
  border: 1px solid #005152 !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3) !important;
  padding: 6px 0 !important;
  min-width: 150px !important;
}

.preprint-dropdown-menu .el-menu-item {
  background-color: #006a71 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 20px !important;
  text-align: left !important;
}

.preprint-dropdown-menu .el-menu-item:hover {
  background-color: #ff8041 !important;
  color: #ffffff !important;
}

.preprint-dropdown-menu .el-menu-item.is-active {
  background-color: #ff8041 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* 确保下拉菜单文字可见 */
.preprint-dropdown-menu .el-menu-item span {
  color: #ffffff !important;
}

.preprint-dropdown-menu .el-menu-item:hover span {
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/navigationBarComponent.vue